import 'es6-promise/auto'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/index.scss'
import './assets/iconfont/iconfont.css'
import App from './App.vue'
import router from './router'
import Api from './api'
import {Cookie} from './filters'
import store from './vuex/store'

Vue.use(ElementUI)
Vue.use(Api)
Vue.use(Cookie)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js